
import {amountFormatter, floatFormatter} from '../Common/util';

// 부문별 진단결과
export const summaryColumnData = [
    {
        title: '분류',
        align: 'center',
        rowSpan: 2,
        colSpan:2,
        children: [
            {
                title: ' ',
                dataIndex: 'code',
                key: 'code',
                width: '60px',
                align: 'center',
                ellipsis : true,
                colSpan : 0,
            },
            {
                title: ' ',
                dataIndex: 'name',
                key: 'name',
                width: '120px',
                align: 'center',
                ellipsis : true,
                colSpan : 0,
            },
        ]
    },
    {
        title: '항목 통계',
        align: 'center',
        children: [
            {
                title: '전체',
                dataIndex: 'total',
                key: 'total',
                width: '60px',
                align: 'center',
                ellipsis : true,
            },
            {
                title: '진단',
                dataIndex: 'check',
                key: 'check',
                width: '60px',
                align: 'center',
            },
            {
                title: '양호',
                dataIndex: 'Y',
                key: 'Y',
                width: '60px',
                align: 'center',
            },
            {
                title: '취약',
                dataIndex: 'N',
                key: 'N',
                width: '60px',
                align: 'center',
            },
            {
                title: '부분이행',
                dataIndex: 'P',
                key: 'P',
                width: '60px',
                align: 'center',
            },
            {
                title: '해당없음',
                dataIndex: 'NA',
                key: 'NA',
                width: '60px',
                align: 'center',
            },
        ]
    },
    {
        title: '진단점수',
        align: 'center',
        children: [
            {
                title: '전체',
                dataIndex: 'total_score',
                key: 'total_score',
                width: '60px',
                align: 'center',
                render: (_ , rowData ) => {
                    return (
                        <>
                            {rowData.total_score}
                        </>
                    );
                },
            },
            {
                title: '평가',
                dataIndex: 'eval_score',
                key: 'eval_score',
                width: '60px',
                align: 'center',
                render: (_ , rowData ) => {
                    return (
                        <>
                            {rowData.eval_score}
                        </>
                    );
                },
            },
            {
                title: '수준',
                dataIndex: 'level',
                key: 'level',
                width: '70px',
                align: 'center',
                render: (_ , rowData ) => {
                    return (
                        <>
                            {rowData.level}%
                        </>
                    );
                },
            },
        ]
    },
];

